import React, { useEffect } from 'react';
import { Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCrown, faUsers, faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { usePageHeader } from '../../../layouts/AdminLayout';
import { StyledTabs, CountPill, TabsBorderDiv } from '../styled';

const UserManagementHeader = ({ 
  activeTab, 
  onTabChange, 
  userCounts = {}
}) => {
  const { setPageHeader } = usePageHeader();

  // Set page header
  useEffect(() => {
    setPageHeader({ title: 'Users' });
  }, [setPageHeader]);

  const tabItems = [
    {
      key: 'admins',
      label: (
        <Space>
          <FontAwesomeIcon icon={faCrown} />
          Admins
          {userCounts.admins !== undefined && (
            <CountPill>{userCounts.admins}</CountPill>
          )}
        </Space>
      )
    },
    {
      key: 'users',
      label: (
        <Space>
          <FontAwesomeIcon icon={faUser} />
          Users
          {userCounts.users !== undefined && (
            <CountPill>{userCounts.users}</CountPill>
          )}
        </Space>
      )
    },
    {
      key: 'volunteers',
      label: (
        <Space>
          <FontAwesomeIcon icon={faUsers} />
          Volunteers
          {userCounts.volunteers !== undefined && (
            <CountPill>{userCounts.volunteers}</CountPill>
          )}
        </Space>
      )
    },
    {
      key: 'registrations',
      label: (
        <Space>
          <FontAwesomeIcon icon={faClipboardList} />
          Registrations
          {userCounts.registrations !== undefined && (
            <CountPill>{userCounts.registrations}</CountPill>
          )}
        </Space>
      )
    }
  ];

  return (
    <div className="header-animate-in">
      <StyledTabs 
        activeKey={activeTab}
        onChange={onTabChange}
        items={tabItems}
        size="large"
      />
      <TabsBorderDiv />
    </div>
  );
};

export default UserManagementHeader;
